var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0085 11.6589C16.6248 12.6858 15.8851 14 14.6822 14H1.59127C0.388319 14 -0.35139 12.6858 0.264921 11.6589L6.81172 0.749201C7.41252 -0.250745 8.86227 -0.248722 9.46172 0.749201L16.0085 11.6589Z",
    fill: "#E44829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedTriangle);
export default __webpack_public_path__ + "static/media/rounded-triangle.a4df1cd90b3d4b51e84a9003f7dacf95.svg";
export { ForwardRef as ReactComponent };